// extracted by mini-css-extract-plugin
module.exports = {"error":"LoginPage_error__1AAWb","form":"LoginPage_form__18I9P","link":"LoginPage_link__h32PQ","newPortalInfo":"LoginPage_newPortalInfo__UULDU"};